<template>
    <node-view-wrapper class="iterator-start-component">
        <node-view-content
            contenteditable="false"
            class="content"
        />
    </node-view-wrapper>
</template>

<script>
    import { NodeViewContent, nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3';

    export default {
        components: {
            NodeViewWrapper,
            NodeViewContent,
        },
        props: nodeViewProps,
    };
</script>
<style lang="scss">
    .iterator-start-component {
        background: #faf594;
        border-top: 1px dashed #ababab;
        border-bottom: 1px dashed #ababab;
        padding: 0.5rem 0.25rem;

        .content {
            font-family: monospace;
        }
    }
</style>
